module.exports = __webpack_public_path__ + "img/21-62O.efc0f94.png";